import {Component, ElementRef, HostListener, ViewChild} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from '../share/localstorage.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {PocsagDetailItem} from './pocsag-detail.module';

@Component({
    selector: 'app-pocsag',
    templateUrl: './pocsag-detail.component.html',
    styleUrls: ['./pocsag-detail.component.css'],
    standalone: false
})


export class PocsagDetailComponent {
    public Ueberschrift: string = this.ls.get('APP_Ueberschrift');
    public PogsagItem: PocsagDetailItem = new PocsagDetailItem(0,'','', '',[''],[''],'','', '');

    public marker = {
        position: new google.maps.LatLng(0, 0), label: {
            color: 'red',
        }, title: 'NEIN', options: {}
    };
    public center;
    public pocsagUID = '';
    public showStichwort = true;
    public showEinheiten = true;



    @ViewChild('hash_PocsagItems') private myScrollContainer: ElementRef;
    @HostListener('window:popstate', ["$event"])
    onPopState(event) {
        setTimeout(() => {

                this.router.navigate(['/pocsag', this.PogsagItem.id]).then(() => {});
             }, 5000);

    }


    constructor(private http: HttpClient,
                private router: Router,
                private ls: LocalStorageService,
                private activatedRoute: ActivatedRoute) {
    }



    back() {
        this.router.navigate(['/pocsag', this.PogsagItem.id]).then(() => {});
    }

    getData() {
        const params = new HttpParams ()
            .set ('uid', this.pocsagUID);

        this.http.get ('https://fappback.devhm.de/pocsagdetails.php', {params})
            .subscribe ((valuefix: string) => {
                    let value = JSON.parse(valuefix) as any as PocsagDetailItem;
                    this.PogsagItem = value;
                    console.log(value);

                    this.setPosition(this.PogsagItem.koordinateX,this.PogsagItem.koordinateY);
                }
            );

    }

    setPosition(KoordinateX, KoordinateY) {

        this.marker = {
            position: new google.maps.LatLng(KoordinateY, KoordinateX)
            ,
            label: {
                color: 'red',
            },
            title: 'Einsatzort',
            options: {animation: google.maps.Animation.BOUNCE},
        };
        this.center = new google.maps.LatLng(KoordinateY, KoordinateX);
    }

    ngOnInit() {


        this.activatedRoute.params.subscribe(
            params => {
                this.pocsagUID = params['id'];
            });
        this.getData();
    }


    protected readonly PocsagDetailItem = PocsagDetailItem;
}
